<template>
  <div
    class="container system-configuration"
    :class="{ collapse: isCollapse }"
  >
    <div class="top-wrapper brand-bg-color">
      <div
        class="systemInfo"
        ref="systemInfo"
        @click="handleGoHome"
      >
        <img
          class="icon"
          :src="logoPath"
          v-if="themeInfo.systemLogoInfo"
        />
        <img
          class="font-img"
          :src="fontPath"
          v-if="!themeInfo.fontType"
          :style="fontImgStyle"
        />
        <span
          class="system-name"
          v-else
        >{{ themeInfo.systemName }}</span>
      </div>
      <div class="u-cut-line"></div>
      <div class="u-page-name">{{ $t("common.sys_config") }}</div>
      <div class="tool-bar">
        <el-dropdown
          @command="onHelpClick"
          style="top: 7px;"
        >
          <span
            class="tool-link"
            :title="$t('indexPage.help')"
          >
            <i class="h-icon-menu_leftbar"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <iframe
              style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;"
              frameborder="0"
            ></iframe>
            <el-dropdown-item
              class="dropdown-item"
              command="about"
            >
              {{ $t("indexPage.about") }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="helpFilePathList.length === 1 && showHelpDoc"
              class="dropdown-item"
              command="help"
            >
               {{ $t("indexPage.help_down_title") }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="helpFilePathList.length > 1 && showHelpDoc"
            >
              <el-dropdown
                @command="onHelpDownloadClick"
                placement="right-start"
                @visible-change="_coverVideo('helpDownload')"
              >
                <section class="hi-df hi-aic help-download-warper">
                  <span class="help-download">{{ $t("indexPage.help_down_title") }}</span>
                  <i class="h-icon-angle_right u-icon-right" />
                </section>
                <el-dropdown-menu
                  slot="dropdown"
                  id="helpDownload"
                  name='helpDownload'
                >
                  <el-dropdown-item v-for="file of helpFilePathList" :command="file.name" :key="file.filePath">
                    {{file.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-dropdown-item>
          </el-dropdown-menu>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          @command="onDropdownClick"
          @visible-change="_coverVideo('portalConfig')"
        >
          <span class="dropdown-link">
            <i class="h-icon-user prefix"></i>
            <span
              class="username"
              :title="userName"
            >{{ userName }}</span>
            <i class="h-icon-angle_down suffix"></i>
          </span>
          <el-dropdown-menu
            id="portalConfig"
            slot="dropdown"
          >
            <iframe
              style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;"
              frameborder="0"
            ></iframe>
            <el-dropdown-item
              class="dropdown-item"
              command="portal-management"
              v-if="showManagePage"
            >
              {{ $t("indexPage.portal_config_title") }}
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              v-if="showModifyPassword"
              command="password-edit"
            >{{ $t("indexPage.modify_pwd_title") }}
            </el-dropdown-item>
            <el-dropdown-item
              :divided="showManagePage || showModifyPassword"
              class="dropdown-item"
              command="logout"
            >{{ $t("indexPage.logout_title") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="left-wrapper">
      <div class="menu-wrapper">
        <el-scrollbar class="auto-height-scrollbar dark">
          <el-menu
            ref="menu"
            :collapse="isCollapse"
            :collapse-btn="true"
            class="sys-menu menu-icon-theme"
            theme="dark"
            wrap-scroll
            unique-opened
            @select="onMenuSelect"
            @click-collapse="handleClickCollapseBtn"
          >
            <template v-for="data in menus">
              <el-submenu
                v-if="
                  !data.fullUrl&&data.children && data.children.length && data.isShow === 0
                "
                :index="data.menuId"
                :key="data.menuId"
              >
                <img
                  class="icon"
                  slot="icon"
                  :src="data.iconInfo.path"
                  :onerror="defaultIcon"
                />
                <template v-slot:title>
                  <span :title="data.name">{{ data.name }}</span>
                </template>
                <menu-item
                  v-for="(sub, index) in data.children"
                  :key="index"
                  :data="sub"
                ></menu-item>
              </el-submenu>
              <el-menu-item
                v-else-if="data.name !== '-' && data.isShow === 0"
                :index="data.menuId"
                :key="data.menuId"
                :title="data.name"
              >
                <img
                  class="icon"
                  slot="icon"
                  :src="data.iconInfo.path"
                  :onerror="defaultIcon"
                />
                {{ data.name }}
              </el-menu-item>
              <div
                class="u-cut-line u-cut-line-color"
                :key="data.id"
                v-else
              ></div>
            </template>
          </el-menu>
        </el-scrollbar>
      </div>
    </div>
    <div class="right-wrapper">
      <menu-management v-if="menuConfig==='menu-config'"></menu-management>
      <template v-else>
        <ErrorPage
          :code="httpCode"
          v-if="httpCode!==200"
        ></ErrorPage>
        <common-iframe
          v-else
          :srcInfo="frameSrc"
          :menuInfo="menuInfo"
          frameborder="0"
          class="frame"
        ></common-iframe>
      </template>
    </div>
    <need-modify-pwd></need-modify-pwd>
    <portal-about
      :aboutDialog="aboutDialog"
      :aboutInfo="aboutInfo"
      :themeInfo="themeInfo"
      @changeVisiable="handleChangeAboutDialog"
    ></portal-about>
    <need-modify-pwd ref="modifyPwd"></need-modify-pwd>
  </div>
</template>

<script>
import API from 'api/api'
import BUS from '../../store/bus'
import needModifyPwd from 'components/need-modify-pwd/need-modify-pwd'
import { ErrorHandleMixin, LoadingMixin, autoCloseMenu, CoverVideo } from 'utils/mixin'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import menuItem from 'components/menu-item/menu-item.vue'
import ApiConfig from 'api/config'
import commonIframe from '../view-page/common-iframe'
import portalAbout from 'components/portal-about/portal-about'
import ErrorPage from '@/components/ErrorPage'
import menuManagement from '../management/menu-management/menu-management'
import { on, off } from '@hui-pro/utils'
import util from 'utils/util'
export default {
  name: 'system-configuration',
  data () {
    return {
      isCollapse: false,
      defaultMenu: '',
      menus: [],
      frameSrc: '',
      menuMap: {},
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`,
      themeInfo: {
        systemLogoInfo: { path: '' }
      },
      aboutDialog: false,
      userName: '',
      showManagePage: false,
      showModifyPassword: false,
      useRefresh:false, //f5刷新
      showHelpDoc:false, //帮助文档
      aboutInfo: {},
      helpFilePath: '',
      helpFilePathList:[],
      httpCode: 200,
      menuConfig: false,

    }
  },
  watch: {
    defaultMenu (value) {
      this.$refs.menu.activeIndex = value
      this.frameSrc = this.menuMap[value].fullUrl
    }
  },
  computed: {
    logoPath () {
      return this.themeInfo.systemLogoInfo
        ? this.themeInfo.systemLogoInfo.path
        : ''
    },
    fontPath () {
      return this.themeInfo.fontImgInfo ? this.themeInfo.fontImgInfo.path : ''
    },
    fontImgStyle () {
      const _fontImg = this.themeInfo.fontImgInfo
      if (!_fontImg) return {}
      const _height = parseInt(_fontImg.height) < 24 ? _fontImg.height : 24
      return {
        height: `${_height}px`
      }
    },
    menuInfo () {
      const menuId = this.menuConfig || this.defaultMenu
      return this.menuMap[menuId]
    },
    ...mapGetters(['navigateSchema'])
  },
  methods: {
    getCurrentMenu () {
      // 在系统管理中 当前活动页id portal-sys-userName中，另外系统管理的iframe获取也用不到id,所以直接 menuId= ""
      return util.isSystemConfiguration() ? '' : this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
    },
    browserTagChange (e) {
      let visibleState = e.target.visibilityState
      if (visibleState === 'hidden') {
        this.postMsgToActIframe('home')
        this.aboutDialog = false
      } else {
        let menuId = this.getCurrentMenu()
        this.postMsgToActIframe(menuId)
      }
    },
    handleGoHome () {
      location.href = '/'
    },
    getActiveMenuId () {
      let menuId = this.$storage.session.get(`portal-sys-${this.$store.state.userName}`)
      if (menuId) {
        API.common.menuVisitState({ menuId: menuId }).then(res => {
          if (res.data === 403) return
          this.httpCode = res.data
          this.defaultMenu = menuId
          if (this.menuMap[menuId]) {
            const sysMenusCacheMap = this.$storage.session.get(`portal-sys-menus-cache-${this.$store.state.userName}`)
            if(sysMenusCacheMap && sysMenusCacheMap[menuId]) this.menuMap[menuId].onceIframeSrc = sysMenusCacheMap[menuId]
            this.$storage.session.remove(`portal-sys-menus-cache-${this.$store.state.userName}`)
          }
        })
      }
    },
    ...mapMutations({
      setSystemMenus: 'SET_SYSTEMT_MENUS',
      setAppMenus: 'SET_APP_MENUS',
      setPersonalMenus: 'SET_PERSONAL_MENUS',
      postMsgToActIframe: 'POST_MSG_TO_ACTIFRAME'
    }),
    handleChangeAboutDialog (status) {
      this.aboutDialog = status
      if (status) {
        this.postMsgToActIframe('home')
      } else {
        let menuId = this.getCurrentMenu()
        this.postMsgToActIframe(menuId)
      }
      let params = { servFlag: 'tipSize', data: { loginOutConfirm: status } }
      for (let i = 0; i < window.frames.length; i++) {
        window.frames[i].postMessage(JSON.stringify(params), '*')
      }
    },
    openView (path) {
      window.open(`${ApiConfig.context}${path}`)
    },
    _getMenus () {
      let _loadingInstance = this._getLoading()
      API.menu
        .getConfigMenu()
        .then(res => {
          _loadingInstance.close()
          this.menus = res.data
          this.setSystemMenus(res.data)
          this.menuMap = {}
          this.menus.forEach(item => {
            this._handleMenu(item, this.menuMap)
          })
          this.getActiveMenuId()
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    // 因为可能存在跨菜单类型间的跳转，所以在这里先把不同类型的菜单都获取了存vuex
    _getPersonalMenusAndSystemMenus () {
      API.menu
        .getPersonalMenu()
        .then(res => {
          this.setPersonalMenus(res.data)
        })
      API.menu
        .getHomeMenu({
          type: 'app'
        })
        .then(res => {
          // 排除掉快捷菜单
          let _menus = res.data.filter(item => {
            return !item.quick
          })
          // 递归生成对应的路径
          _menus.forEach(item => {
            this._handleAppMenu('/index/view', item)
          })
          // 将处理后的菜单列表放入Vuex
          this.setAppMenus(JSON.parse(JSON.stringify(_menus)))
        })
    },
    _handleAppMenu (prex, menu) {
      menu.children = menu.children || []
      menu._hasChild = menu.children.length > 0
      // 寻找出指定为首页的菜单
      if (menu.index) {
        if (!menu.fullUrl || menu.fullUrl.trim() === '') {
          menu._path = '/index/home'
          menu.fullUrl = ''
        }
        this.indexMenu = menu
      }
      if (!menu._path) {
        menu._path = `${prex}/${menu.menuId}`
        if (menu.children.length > 0) {
          menu.children.forEach(item => {
            this._handleAppMenu(menu._path, item)
          })
        }
      }
    },
    // 获取关于
    getAbout () {
      API.common.getAbout().then(res => {
        this.aboutInfo = res.data
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    _getBasicInfo () {
      API.common
        .basicInfo()
        .then(res => {
          this.setUserName({ userName: res.data.userName })
          this.userName = res.data.userName || ''
          this.showManagePage = res.data.showManagePage
          this.showModifyPassword = res.data.showModifyPassword
          this.useRefresh = res.data.useRefresh
          this.showHelpDoc = res.data.showHelpDoc
        })
        .catch(this._handleError)
    },
    _handleMenu (menu, map) {
      map[menu.menuId] = menu
      if (menu.children && menu.children.length && !menu.fullUrl) {
        menu.children.forEach(item => {
          this._handleMenu(item, map)
        })
      } else if (this.defaultMenu === '') {
        this.defaultMenu = menu.menuId
      }
    },
    onMenuSelect (menuId) {
      if (menuId === 'menu-config') {
        this.httpCode = 200
        this.menuConfig = menuId
      } else {
        this.menuConfig = menuId
        this.httpCode = 200
        const _menu = this.menuMap[menuId]
        this.$storage.session.set(`portal-sys-${this.$store.state.userName}`, menuId)
        this.frameSrc = _menu.fullUrl
      }
    },
    handleClickCollapseBtn (flag) {
      if (flag) {
        this.isCollapse = flag
      } else {
        this.isCollapse = !this.isCollapse
      }
      let msg = {
        method: 'handleCollapseChange',
        status: this.isCollapse
      }
      let arugs = JSON.stringify(msg)
      document.getElementById('iseframe').contentWindow.postMessage(arugs, '*')
    },
    // 获取主题信息
    _getThemeInfo () {
      API.theme
        .query()
        .then(res => {
          this.themeInfo = res.data
        })
    },
    onHelpClick (command) {
      if (command === 'about') {
        this.handleOpenAbout()
      } else if (command === 'help') {
        window.open(this.helpFilePath)
      }
    },
    onHelpDownloadClick(command){
      for(let file of this.helpFilePathList){
        if(file.name === command ){
          this.downLoadHelp(file);
          break;
        }
      }
    },
    // 下载帮助文档
    downLoadHelp ({filePath}) {
      if(filePath) window.open(filePath)
    },
    handleOpenAbout () {
      this.aboutDialog = true
    },
    onDropdownClick (command) {
      // 根据点击的下拉菜单命令触发事件
      if (command === 'portal-management') {
        this.openView('/management')
      } else if (command === 'password-edit') {
        this.modifyPwd(true)
      } else if (command === 'logout') {
        let params = { servFlag: 'tipSize', data: { loginOutConfirm: true } }
        for (let i = 0; i < window.frames.length; i++) {
          window.frames[i].postMessage(JSON.stringify(params), '*')
        }
        this.postMsgToActIframe('home')
        this.$confirm(this.$t('common.login_out_tips'), {
          confirmButtonText: this.$t('common.confirmBtn_text'),
          cancelButtonText: this.$t('common.cancelBtn_text'),
          type: 'question',
          closeOnPressEscape: true
        }).then(() => {
          this._logout()
        }).catch(() => {
          let menuId = this.getCurrentMenu()
          this.postMsgToActIframe(menuId)
          let params = { servFlag: 'tipSize', data: { loginOutConfirm: false } }
          for (let i = 0; i < window.frames.length; i++) {
            window.frames[i].postMessage(JSON.stringify(params), '*')
          }
        })
      } else if (command === 'diy-portal') {
        this.openView('/management/home-configuration?branch=diy-portal')
      }
    },
    _logout () {
      // 清空SessionStorage中保存的数据
      // this.$storage.session.clear()
      window.location.href = ApiConfig.logoutSrc
    },
    _getHelpPath () {
      API.common
        .getDownloadHelp()
        .then(res => {
          if (res.data.list && res.data.list.length) {
            this.helpFilePath = res.data.list[0].filePath
            this.helpFilePathList = res.data.list
          }
        })
        .catch(this._handleError)
    },
    modifyPwd (flag) {
      this.$refs.modifyPwd.modifyPwd(flag)
    },
    _windowUnload () {
      if(!this.useRefresh) {
        return this.$storage.session.remove(`portal-sys-menus-cache-${this.$store.state.userName}`)
      }
      if (this.$store.navigateSchema === 'nav-type1') {
        const menus = this.$storage.session.get(`portal-tab-menus-${this.$store.state.userName}`) || []
        if (menus.length) {
          for (let item of menus) {
            if (item.menuId !== 'home') {
              const pathname = document.getElementById(`iframe${item.menuId}`).contentDocument.location.pathname
              item.onceIframeSrc = pathname
            }
          }
          this.$storage.session.set(`portal-tab-menus-${this.$store.state.userName}`, menus)
        }
      } else {
        try{
          const pathname = document.getElementById('iseframe') && document.getElementById('iseframe').contentDocument.location.pathname
          const sysMenuCode = this.$storage.session.get(`portal-sys-${this.$store.state.userName}`)
          if(sysMenuCode && !util.isPortalPage(pathname)){
            this.$storage.session.set(`portal-sys-menus-cache-${this.$store.state.userName}`, {[`${sysMenuCode}`]:pathname})
          }
        }catch(e){
          console.log(e)
        }

      }
    },
    ...mapActions(['setUserName']),
    // 菜单跳转
    handleGoToApp (menu) {
      this.$refs.menu.activeIndex = menu.menuId
      this.frameSrc = menu.fullUrl
    }
  },
  mounted () {
    BUS.$on('gotoMenu', this.handleGoToApp)
    this._autoCloseMenu()
    this._getMenus()
    this._getThemeInfo()
    this._getBasicInfo()
    this._getHelpPath()
    this.getAbout()
    this._getPersonalMenusAndSystemMenus()
    top.window.extendScreen_closeMenu = this.handleClickCollapseBtn
    on(document, 'visibilitychange', this.browserTagChange)
    window.addEventListener('unload', this._windowUnload)
  },
  mixins: [ErrorHandleMixin, LoadingMixin, autoCloseMenu, CoverVideo],
  components: {
    menuItem,
    needModifyPwd,
    commonIframe,
    portalAbout,
    ErrorPage,
    menuManagement
  },
  beforeDestroy () {
    off(document, 'visibilitychange', this.browserTagChange)
    window.removeEventListener('unload', this._windowUnload)
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/wi-font/iconfont.css";
.system-configuration.container {
  height: 100%;
  width: 100%;
  position: relative;
  .top-wrapper {
    position: relative;
    width: 100%;
    height: 36px;
    .systemInfo {
      float: left;
      height: 32px;
      line-height: 32px;
      padding-left: 4px;
      margin-top: 2px;
      cursor: pointer;
      .icon {
        height: 32px;
        width: 32px;
        display: block;
        float: left;
      }
      .font-img {
        height: 100%;
        width: auto;
        display: inline-block;
        vertical-align: middle;
      }
      .system-name {
        font-size: 16px;
        color: #fff;
        margin-left: 4px;
      }
    }
    .u-cut-line {
      width: 1px;
      height: 16px;
      background: rgba(255, 255, 255, 0.2);
      float: left;
      margin-left: 16px;
      margin-top: 10px;
    }
    .u-page-name {
      float: left;
      height: 24px;
      font-size: 12px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.85);
      padding: 0 8px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 2px;
      box-sizing: border-box;
      margin: 6px 0 0 16px;
      background: rgba(255, 255, 255, 0.08);
    }
    .tool-bar {
      position: relative;
      float: right;
      margin-right: 16px;
      height: 100%;
      color: #fff;
      /deep/ .el-dropdown {
        color: #fff;
      }
      .tool-link {
        position: relative;
        opacity: 0.8;
        filter: alpha(opacity=80);
        margin-right: 8px;
        cursor: pointer;
        text-decoration: none;
        z-index: 102;
        .h-icon-menu_leftbar {
          font-size: 24px;
        }
        .data-view {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-image: url("../../assets/images/system_data display.png");
          background-repeat: no-repeat;
        }
        &:hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }
        .u-message {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-image: url("../../assets/images/msg_icon.png");
          background-repeat: no-repeat;
        }
        &:hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }
        .tool-icon {
          width: 16px;
          height: 16px;
          cursor: pointer;
          opacity: 0.8;
        }
        .tool-icon:hover {
          opacity: 1;
        }
      }
      .username {
        display: inline-block;
        max-width: 80px;
        vertical-align: middle;
        position: relative;
        top: -2px;
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap; /*规定段落中的文本不进行换行 */
      }
      .dropdown-link {
        opacity: 0.8;
        filter: alpha(opacity=80);
        cursor: pointer;
        &:hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }
        .prefix {
          margin-right: 8px;
          font-size: 24px;
          position: relative;
          top: 6px;
        }
        .suffix {
          margin-left: 8px;
          position: relative;
          font-size: 16px;
          top: 3px;
        }
      }
    }
  }
  .left-wrapper {
    width: 240px;
    height: calc(~"100% - 36px");
    box-sizing: border-box;
    padding-left: 10px;
    padding-top: 35px;
    position: relative;
    .title {
      font-size: 0;
      .icon {
        width: 38px;
        height: 33px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
      }
      .info {
        height: 33px;
        vertical-align: middle;
        line-height: 33px;
      }
    }
    .menu-wrapper {
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      overflow: auto;
      /deep/ .el-scrollbar__bar:active,
      /deep/ .el-scrollbar__bar:hover {
        background: rgba(255, 255, 255, 0);
      }
      .icon {
        width: 100%;
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        &.no-icon {
          background: none !important;
        }
      }
      .is-active {
        .icon {
          &.no-icon {
            background: none !important;
          }
        }
      }
      .title {
        font-size: 12px;
      }
      .submenu-title {
        .icon {
          top: 0;
        }
      }
      /deep/ .el-submenu__title {
        .el-submenu__title--text {
          display: inline-block;
          width: calc(~"100% - 32px");
          top: -3px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .u-cut-line {
        width: calc(~"100% - 16px");
        height: 1px;
        margin: 4px 8px;
      }
    }
  }
  .right-wrapper {
    position: absolute;
    top: 36px;
    bottom: 0;
    left: 240px;
    right: 0;
    /deep/ .h-page-container {
      height: 100%;
    }
    .frame {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  &.collapse {
    .left-wrapper {
      width: 48px;
      padding: 12px 5px 0;
      .title {
        .icon {
          margin-right: 0;
        }
        .info {
          display: none;
        }
      }
    }
    .right-wrapper {
      left: 48px;
    }
  }
}
.help-download-warper{
  .help-download{
    color:#666666;

  }
  .u-icon-right{
    font-size: 18px;
  }
}
</style>
